
import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';

import { PrivacyPolicyComponent } from './components/footer/privacy-policy/privacy-policy.component';
import { TermsOfServiceComponent } from './components/footer/terms-of-service/terms-of-service.component';
import { ContactsComponent } from './components/footer/contacts/contacts.component';
import { PageNotFoundComponent } from './components/generic/page-not-found/page-not-found.component';
import { GenericErrorComponent } from './components/generic/generic-error/generic-error.component';

const appRoutes: Routes = [
    { path: 'home', redirectTo: '/winoPublishing/home', pathMatch: 'full' },
    { path: 'contacts', component: ContactsComponent },
    { path: 'privacy-policy', component: PrivacyPolicyComponent },
    { path: 'terms-of-service', component: TermsOfServiceComponent },
    { path: 'pageNotFound', component: PageNotFoundComponent },
    { path: 'genericError/:message', component: GenericErrorComponent },
    { path: 'winoMembership', loadChildren: () => import('./modules/wino-membership/wino-membership.module').then(m => m.WinoMembershipModule) },
    { path: 'winoPublishing', loadChildren: () => import('./modules/wino-publishing/wino-publishing.module').then(m => m.WinoPublishingModule) },
    { path: 'winoLibrary', loadChildren: () => import('./modules/wino-library/wino-library.module').then(m => m.WinoLibraryModule) },
    //{ path: 'winoLibrary/*', loadChildren: () => import('./modules/wino-library/wino-library.module').then(m => m.WinoLibraryModule)},
    { path: '',  redirectTo: '/winoPublishing/home', pathMatch: 'full' },
    { path: '**', redirectTo: 'pageNotFound', pathMatch: 'full' }
];

@NgModule({
  imports: [
    RouterModule.forRoot(
      appRoutes,
      {
        scrollPositionRestoration: 'top'
        //preloadingStrategy: PreloadAllModules
      },
    )
  ],
  exports: [
    RouterModule
  ]
})
export class AppRoutingModule { }

/*****************************************************************************
 * 
 * PATH SPECIFICATION SAMPLES
 * --------------------------
 * {path: 'category/:id/:categoryName', component: ProductListComponent},
 * {path: 'category/:id', component: ProductListComponent},
 * {path: 'search/:keyword', component: ProductListComponent},
 * {path: 'details/:id', component: ProductDetailsComponent},
 * {path: 'cart', component: CartDetailsComponent},
 * {path: 'category', component: ProductListComponent},
 * {path: 'checkout', component: CheckoutComponent},
 * {path: 'products', component: ProductListComponent},
 * {path: 'search', component: ProductListComponent},
 * {path: 'details', component:ProductDetailsComponent},
 * {path: '', redirectTo: '/products', pathMatch: 'full'},
 * {path: '**', redirectTo: '/products', pathMatch: 'full'}
 * 
 *****************************************************************************/